
export function buildComicsQuery(characterID,limit){
    const hash = localStorage.getItem("marvelHash");
    const publicMarvelKey = "3a7ee881bddc680e47706a7a2d04a326";
    const timeStamp = "&ts=1";    
    const requestURL = "https://gateway.marvel.com:443/v1/public/characters/";
    const listOfComicsDataQuery = requestURL + characterID + "/comics?limit=" + limit + "&apikey=" + publicMarvelKey + "&hash=" + hash + timeStamp;
    return listOfComicsDataQuery;
}


// WEBPACK FOOTER //
// ./src/components/includes/buildComicsQuery.js